/** Base URL ảnh SSO trên auth (avatar dùng chung các hệ thống). */
export function getAuthImageBaseUrl(): string {
  const authUrl = (process.env.REACT_APP_AUTH_URL || '').replace(/\/$/, '')
  if (authUrl) return `${authUrl}/auth-backend/image`
  return (process.env.REACT_APP_IMAGE_PATH || '').replace(/\/$/, '')
}

/**
 * URL hiển thị ảnh đại diện SSO.
 * - Absolute / data URI → giữ nguyên (R2 bán hàng, URL auth, localhost…).
 * - Tên file / relative → gắn base ảnh auth (không dùng IMAGE_PATH mua hàng).
 */
export function getAvatarDisplayUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:image/')
  ) {
    return trimmed
  }
  const base = getAuthImageBaseUrl()
  if (!base) return trimmed
  return `${base}/${trimmed.replace(/^\//, '')}`
}

/** Alias — ảnh sản phẩm/kho vẫn dùng IMAGE_PATH mua hàng. */
export function getImageDisplayUrl(url: string | null | undefined): string {
  if (!url || typeof url !== 'string') return ''
  const trimmed = url.trim()
  if (!trimmed) return ''
  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('data:image/')
  ) {
    return trimmed
  }
  const base = (process.env.REACT_APP_IMAGE_PATH || '').replace(/\/$/, '')
  return `${base}/${trimmed.replace(/^\//, '')}`
}
